export default {
    invoices(state) {
        return state.invoices
    }
}
